<template>
  <div class="card card--transparent client-card">
    <div class="card--container">
      <div class="client-basic-info row">
        <div class="row col-at-xs">
          <div class="client-image">
            <img :src="client.image || '/img/personHead.png'" />
          </div>
          <div class="client-info">
            <h2>{{client.first_name}} {{client.last_name}}</h2>
            <div v-if="client.habit_program">
              <h4>Program</h4> 
              <div>{{client.habit_program.name}}</div>
            </div>
            <div>
              <h4>Last Login</h4>
              <div>{{lastLogin}}</div>
            </div>
          </div>
        </div>
        <div class="actions">
          <action 
            icon="edit" 
            name="edit" 
            @click="$router.push('/client-detail/' + client.id + '/settings')" />
          <!-- <action icon="chat" name="chat" /> -->
        </div>
      </div>
    </div>
    <div class="row space-around progress-charts">
      <progress-chart 
        v-for="(key, val) in progress" 
        :key="val" :completed="key" :title="val"
        @click="go(val)"/>
    </div>
    <reflection-chart 
      @click="$router.push({name: 'clientReflections', params: {id: client.id}})"
      v-if="stoppedLoadingReflections" 
      :reflections="reflections" />
  </div>
</template>

<script>
import moment from "moment";
import action from "./action";
import store from "@/services/api/store";
import reflectionChart from "./reflectionChart";
import progressChart from "./progressChart";

export default {
  props: ["client"],
  components: { action, reflectionChart, progressChart },
  data() {
    return {
      reflections: [],
      progress: [],
      stoppedLoadingReflections: false
    };
  },
  created() {
    store
      .detailRoute(`coaches/clients/${this.client.id}/reflections/`)
      .then(reflections => {
        this.reflections = reflections;
      }).finally(() => {
        this.stoppedLoadingReflections = true
      })

    store
      .detailRoute(`coaches/clients/${this.client.id}/current_progress/`)
      .then(progress => {
        this.progress = progress;
      });
  },
  methods: {
    go(path) {
      this.$router.push(`/client-detail/${this.client.id}/${path}`)
    }
  },
  computed: {
    lastLogin() {
      return moment(this.client.last_login).format("ll")
    }
  }
}
</script>

<style lang="less" scoped>
.client-card {
  font-weight: 100;
  font-size: 12px;
  .progress-charts {
    flex-wrap: wrap;
  }
  h4 {
    font-weight: 100;
    font-size: 12px;
  }

  .client-basic-info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .client-image {
    img {
      height: 100px;
      width: 100px;
      object-fit: cover;
      border-radius: 50%;
      border-style: solid;
      border-color: white;
      border-width: 2px;
    }
  }
  .client-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 10px;
  }
  h4 {
    text-transform: uppercase;
  }
};

</style>
